export class BikeModel {
  constructor(id, bikeNumber, tenant, location, iconUri, isSponsored = false) {
    this.id = id;
    this.bikeNumber = bikeNumber;
    this.tenant = tenant;
    this.location = location;
    this.icon = iconUri;
    this.isSponsored = isSponsored;
  }
}
